import React from 'react';
import { Navigate } from 'react-router-dom';

import { EUserRole } from '@/enum';
import useUser from '@/store/useUser';

export const PrivateRoute = ({
  children,
  permission,
}: {
  children: React.ReactNode;
  permission?: EUserRole | EUserRole[];
}) => {
  const {
    user: { token, is_access },
  } = useUser();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (permission) {
    const required = Array.isArray(permission) ? permission : [permission];

    const hasAnyPermission = required.some(
      (perm) => (is_access as EUserRole) === perm
    );

    if (!hasAnyPermission) {
      return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
};

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const {
    user: { token, is_access },
  } = useUser();

  if (token) {
    if (is_access === EUserRole.TEACHER) {
      return <Navigate to="/teacher/dashboard" replace />;
    }
    if (is_access === EUserRole.PARENT) {
      return <Navigate to="/parent/dashboard" replace />;
    }
    if (is_access === EUserRole.SCHOOL) {
      return <Navigate to="/school/dashboard" replace />;
    }
  }

  return <>{children}</>;
};
